import React from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { checkIsActive, KTSVG } from '../../../helpers'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  iconSize?: string
  disabled?: boolean
  children?: React.ReactNode
}

const AsideMenuItem: React.FC<Props> = ({
  children, to, title, icon, iconSize, hasBullet = false, disabled,
}) => {
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to)

  return (
    <div className='ami-item' style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <Link
        to={to}
        className={`ami-link${isActive ? ' ami-link--active' : ''}${disabled ? ' ami-link--disabled' : ''}`}
        style={{ pointerEvents: disabled ? 'none' : 'auto' }}
        tabIndex={disabled ? -1 : 0}
      >
        {hasBullet && <span className='ami-bullet' />}
        {icon && (
          <span className='ami-icon'>
            <KTSVG path={icon} className={`svg-icon-${iconSize || '4'}`} />
          </span>
        )}
        <span className='ami-title'>{title}</span>
        {isActive && <span className='ami-active-bar' />}
      </Link>
      {children}
    </div>
  )
}

export { AsideMenuItem }